import type { ReliabilityTier } from '../types/index.js';

interface ConfidenceBadgeProps {
  reliability: ReliabilityTier;
  sampleSize: number;
}

/** Spec 230 — restyled onto `.hub-chip` + tone; tier→tone mapping preserves
 * the original semantic ordering (directional=weakest/warn, operational=mid/
 * info, high_confidence=strongest/ok). */
const TIER_CONFIG: Record<ReliabilityTier, { label: string; tone: 'warn' | 'info' | 'ok'; margin: string }> = {
  directional: { label: 'Directional', tone: 'warn', margin: '+/-20pp' },
  operational: { label: 'Operational', tone: 'info', margin: '+/-10pp' },
  high_confidence: { label: 'High confidence', tone: 'ok', margin: '+/-5pp' },
};

export function ConfidenceBadge({ reliability, sampleSize }: ConfidenceBadgeProps) {
  const config = TIER_CONFIG[reliability];
  return (
    <span
      className={`hub-chip hub-chip--${config.tone}`}
      title={`${config.label} (${config.margin}, n=${sampleSize})`}
    >
      {config.label}
      <span className="opacity-70">n={sampleSize}</span>
    </span>
  );
}
